<!--
 * @Author: yindengli
 * @Date: 2023-06-26 11:04:28
 * @LastEditTime: 2023-11-01 13:34:25
 * @LastEditors: yindengli
 * @Description: 
 * @FilePath: \openseeyon-index-front\src\components\HeaderBar.vue
-->
<template>
  <div :class="['header-nav']">
    <div class="left-div">
      <router-link to="/home">
        <a-space class="logo">
          <img src="../assets/imgs/logo.png" alt="致远开放平台" />
          <span class="logo-text">致远开放平台</span>
        </a-space>
      </router-link>
      <div class="menu-version" @click="switchVersion">
        <span class="version-name">{{ curVersionName }}</span>
        <a-icon type="swap" :style="{ fontSize: '16px' }" />
      </div>
    </div>

    <div class="right-div">
      <a-icon type="menu" size="large" class="menu-icon" @click="handleMenu" />
      <ul :class="['nav-list', { 'show': isShowMenu }]" v-click-outside="handleClickOutside">
        <li
          :class="['nav-item', { active: item.key == curKey }, (item.children && item.children.length) ? 'down-arrow' : '']"
          v-for="(item, index) in navList" :key="item.key + index" @click="navClick(item.key, item)">
          <a v-if="item.link" :href="item.link" class="extral-link">
            {{ item.title }}
          </a>
          <template v-else>
            {{ item.title || "" }}
          </template>
          <ul v-if="item.children && item.children.length > 0"
            class="dropdown-menu">
            <li v-for="(child, childIndex) in item.children" :key="child.key + childIndex">
              <div v-if="child.link" @click="navClick(child.key, child)">
                <a :href="checkLink(child.link)" :target="child.target ? child.target : '_self'"
                  :class="['dropdown-link']">{{ child.title }}</a>
              </div>
              <template v-else>
                <span @click="navClick(child.key, child)">{{ child.title || "" }}</span>
              </template>
            </li>
          </ul>
        </li>
      </ul>
      <div class="login"  v-if="!loginKey">
        <div :class="curKey == 'login' ? 'btn-login' : ''" @click="handleLogin">登录</div>
      </div>
      <div v-else class="user-info" @click="handleUser">
        <a-dropdown>
          <a class="user-title">
            <span :title="nickName">{{ nickName }}</span>
            <a-icon type="down" />
          </a>
          <a-menu slot="overlay" @click="handleClick">
            <a-menu-item key="logout">
              <a href="javascript:;">退出登录</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <span class="user-message" @click.stop="seeInfoMessage" v-if="infoCount && infoCount > 0">
          <a-icon type="bell" />
          <span class="message-number">{{ infoCount }}</span>
        </span>
      </div>
    </div>

    <a-modal :maskStyle="{ 'animation': 'none', 'background': '#000', 'opacity': '0.7' }" :width="740"
      class="login-modal" v-model="isShowLoginDlg" destroyOnClose :footer="false" centered title="">
      <Login @loginSuccess="loginSuccess" />
    </a-modal>

    <!-- 反馈详情 -->
    <info-message :visible="infoMessageVisible" @closeInfoMessage="closeInfoMessage"></info-message>
  </div>
</template>

<script>
import axios from 'axios';
import eventBus from '@/utils/eventBus'
import request from '@/utils/request'
import { getCookie, setCookie } from "@/utils/common";
import vClickOutside from "v-click-outside";
import { getUuidByToken, logoutOpenSeeyon } from '@/api/index.js';

import infoMessage from './infoMessage'

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  name: "header-nav",
  components: {
    infoMessage
    // Login
  },
  props: {
    navList: Array,
  },
  data() {
    return {
      // curNavList: [],
      curKey: "home",
      preLoginKey: "",
      isShowMenu: false,
      isShowLoginDlg: false,
      loginKey: "",
      isShare: false,
      nickName: "",
      infoCount: 0,
      showBell: false,
      infoMessageVisible: false,
      version: {
        V5: 'V5 开放平台',
        V8: 'V8 开放平台'
      },
      curVersion: 'V5',
    };
  },
  computed: {
    curVersionName() {
      return this.version[this.curVersion]
    }
  },
  created() {
    eventBus.$on("loginSuccess", (isShare) => {
      this.loginSuccess(isShare);
    });
    // 登录失效
    eventBus.$on("logionExpired", () => {
      this.loginKey = '';
      setCookie("loginKey", "");
      setCookie("nickName", "");
    });
    this.loginKey = getCookie("loginKey");
    // this.navList = this.navList;

    // this.$router.push("/home");
    var curRoute = this.$route.path;
    this.curKey = curRoute.slice(1);
    // this.navClick(curRoute.slice(1));
    const version = window.localStorage.getItem("openSeeyonVersion");
    if(version && this.version[version]){
      this.curVersion = window.localStorage.getItem("openSeeyonVersion");
    }else{
      window.localStorage.setItem("openSeeyonVersion", this.curVersion);
    }
  },
  methods: {
    handleClickOutside() {
      this.isShowMenu = false;
    },
    handleMenu() {
      setTimeout(() => {
        this.isShowMenu = !this.isShowMenu;
      });

    },
    navClick(key, navItem) {
      const { link, children } = navItem || {};
      if (link && link.indexOf('support.seeyon.com') != -1) {
        if (getCookie('loginKey')) {
          getUuidByToken({ token: decodeURIComponent(getCookie('loginKey')) }).then((res) => {
            if (res.code == 200) {
              const { uuid } = res.data
              if (uuid) {
                const url = `${process.env.VUE_APP_supportUrl}/transferPage.html?target=` + encodeURIComponent(navItem.link + '&uuid=' + uuid)
                window.open(url)
              }
            }
          })
        } else {
          this.handleLogin();
        }
        return
      }
      if(children && children.length > 0){
        return
      }
      console.log('key--->', key)
      switch (key) {
        case "doc":
          break;
        case "projects":
          this.openProject();
          break;
        case "login":
          var loginRoute = {};
          loginRoute.name = "login";
          loginRoute.query = this.$route.query || {};
          this.$router.push(loginRoute);
          this.curKey = key;
          break;
        case "sendQuestion":
          var questionRoute = {};
          questionRoute.name = "sendQuestion";
          questionRoute.query = this.$route.query || {};
          this.$router.push(questionRoute);
          this.curKey = key;
          break;
        case "faq":
          this.$router.push({name: key, params: {faqCategoryId: -1}});
          this.curKey = key;
          break;
        default:
          this.$router.push("/" + key);
          this.curKey = key;
          break;
      }
      this.isShowMenu = false;
    },
    checkLink(link){
      if(link.indexOf('support.seeyon.com') != -1){
        return void(0);
      }
      return link;
    },
    /**
     * 点击登录
     */
    handleLogin() {
      this.preLoginKey = this.curKey;
      // this.$router.push("/login?back_path=" + this.$route.name);
      this.$toLogin();
      this.curKey = "login";
    },
    /**
     * 点击用户，进入第三方个人中心
     */
    handleUser() {
      // "https://support.seeyon.com/personal_center.html"
    },
    handleClick({key}) {
      switch (key) {
        case 'logout':
          logoutOpenSeeyon({token: this.loginKey})
              .then( ()=> {
                this.loginKey = '';
                setCookie("loginKey", "");
                setCookie("nickName", "");
          });
          break;
      }
    },
    openProject() {
      // 上传后放开
      var strcookie = document.cookie; //获取cookie字符串
      var arrcookie = strcookie.split("; "); //分割
      var userName;
      var ticket;
      var authenicationState;
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == "userName") {
          userName = arr[1];
        }
        if (arr[0] == "ticket") {
          ticket = arr[1];
        }
        if (arr[0] == "authenicationState") {
          authenicationState = arr[1];
        }
      }
      if (userName == undefined || ticket == undefined) {
        window.open("http://open.seeyon.com/seeyonbbs/?user-login.htm&from=open");
      } else if (authenicationState == 0 || authenicationState == undefined) {
        window.open("http://open.seeyon.com/seeyonbbs/?my-authentication.htm");
      } else {
        window.open("http://open.seeyon.com/seeyonbbs/?my-authentication.htm?sso_flag=success");
      }
    },
    // 登录成功
    // eslint-disable-next-line no-unused-vars
    loginSuccess(isShare) {
      this.loginKey = getCookie("loginKey");
      const fromType = this.$route.query && this.$route.query.fromType;
      if (fromType === 'send') {
        this.goSendPage();
        return;
      }
      if (fromType === 'officePlugin') {
        this.goOfficePlugin();
        return;
      }
      this.isShare = isShare;
      if (!isShare) {
        this.navClick(this.preLoginKey);
      }
    },
    /**
    * 跳转反馈页面
    */
    goSendPage() {
      const fromType = this.$route.query && this.$route.query.fromType;
      if (!fromType) return;
      let route = {};
      route.name = "sendQuestion";
      route.query = this.$route.query || {};
      this.$router.push(route);
    },
    goOfficePlugin() {
      const fromType = this.$route.query && this.$route.query.fromType;
      if (!fromType) return;
      this.$router.push({ name: 'officePlugin' });
    },
    /**
     * 获取登录信息
     */
    getLoginInfo() {
      request({
        url: "/faq/login/userInfo/getUserInfo",
        method: 'post',
        data: { token: this.loginKey }
      }).then(res => {
        if (res) {
          if (res && res.data) {
            this.nickName = res.data.userName;
            setCookie("nickName", res.data.userName);
          } else {
            setCookie("nickName", "");
          }
        } else {
          console.log("获取用户信息失败");
          setCookie("nickName", "");
        }
      })
    },
    /**
     * 获取反馈信息
    */
    getSendQuestionNum() {
      let url = '/faq/problemFeedback/findMyNewFeedbackCount';
      const token = getCookie('loginKey');
      axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
      axios.defaults.headers.token = token;
      axios.get(url).then(res => {
        if (!res) return;
        let data = res.data;
        if (data.code === 0) {
          this.infoCount = data.data
          if (this.infoCount > 0) {
            this.showBell = true;
          }
        }
      })
    },
    /**
     * 查看提示信息
    */
    seeInfoMessage() {
      this.infoMessageVisible = true;
      this.infoCount = 0;
    },
    closeInfoMessage() {
      this.infoMessageVisible = false;
    },
    switchVersion() {
      this.curVersion = this.curVersion == 'V5' ? 'V8' : 'V5';
      window.localStorage.setItem("openSeeyonVersion", this.curVersion);
      // this.$router.go(0); safira不生效
      window.location.reload();
    }
  },
  watch: {
    "$route.path"(val) {
      this.curKey = val ? val.slice(1) : "/";
    },
    loginKey(val) {
      if (val) {
        // 已登录
        this.getLoginInfo();
        this.getSendQuestionNum();
      }
    }
  },
};
</script>

<style scoped lang="scss">
.header-nav {
  width: 100%;
  height: 56px;
  position: fixed;
  z-index: 901;
  top: 0;
  left: 0;
  padding-left: 1.2%;
  margin: 0;
  background: #fff;
  color: #000000;
  box-shadow: 0px 2px 24px 0px rgba(0, 0, 0, 0.10);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
}
ul,
li {
  list-style: none;
}

.clearfixr {
  zoom: 1;
}

/*在IE6, 7下zoom: 1会触发hasLayout，从而使元素闭合内部的浮动 height:1%效果也是一样。
*/
.left-div {
  display: flex;
  align-items: center;
  flex: 1;

  .menu-version {
    margin-left: 50px;
    color: #007AFF;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .version-name {
    margin-right: 4px;
  }
}

.logo img {
  width: 40px;
}

.logo-text {
  color: #000;
  line-height: 24px;
}

.right-div {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  font-size: 16px;
}

.nav-list {
  display: flex;
  margin: 0;
}

.nav-list.show {
  display: flex;
}

.nav-item {
  position: relative;
  display: inline-block;
  padding: 10px 25px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  letter-spacing: 0;
  cursor: pointer;

  &.down-arrow{
    padding-right: 35px;
  }
}

.menu-icon {
  padding: 10px;
  display: none;
  cursor: pointer;
}

.login {
  margin-left: 10px;
  background: #007aff;
  color: #ffffff;
  height: 56px;
  line-height: 56px;
  padding: 0 40px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
}

.user-info {
  color: #40a9ff;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
  display: flex;
  align-items: center;
  padding-right: 20px;
  padding-left: 20px;
}

.user-title {
  display: flex;
  align-items: center;

  span {
    display: inline-block;
    max-width: 90px;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0 6px 0 0;
  }
}

.user-message {
  display: inline-block;
  margin-left: 10px;
  font-size: 20px;
  position: relative;
  cursor: pointer;
}

.message-number {
  display: block;
  color: #f00;
  z-index: 2;
  top: 0px;
  left: 16px;
  position: absolute;
  font-size: 15px;
  font-weight: bold;

}


/* 头部适应窗口宽度 */
@media screen and (max-width: 1300px) {
  .header-nav {
    font-size: 16px;
  }
  .right-div{
    font-size: 14px;
  }
  .nav-item {
    padding: 10px 24px;
    &.down-arrow{
      padding-right: 24px;
      &::after{
        right: 10px;
      }
    }
  }
}

@media screen and (max-width: 1158px) {
  .nav-item {
    padding: 10px 16px;
  }
}

@media screen and (max-width: 1060px) {
  .left-div {
    .logo-text {
      display: none;
    }

    .menu-version {
      margin-left: 0;
    }
  }
  .nav-item {
    &.down-arrow{
      padding-right: 16px;

      &::after{
        right: 2px;
      }
    }
  }
}

@media screen and (max-width: 868px) {
  .header-nav {
    font-size: 14px;
  }

  .left-div {
    .logo-text {
      display: none;
    }

    .menu-version {
      margin-left: 0;
    }
  }

  .right-div{
    font-size: 14px;
    .down-arrow::after{
      right: 0;
    }
    .dropdown-menu{
      right: 90px;
      top: 0;
      margin-top: 0;
    }
  }
  .nav-list {
    padding: 10px 10px 0;
    text-align: center;
    display: none;
    background: #fff;
    box-shadow: 0 0 6px 0px #eee;
    flex-direction: column;
    position: absolute;
    right: 4px;
    top: 40px;
  }

  .nav-item {
    padding: 0 20px;
    margin-bottom: 16px;
  }

  .menu-icon {
    display: block;
  }

  .login {
    padding: 0 20px;
    background: transparent;
    height: 34px;
    line-height: 34px;
    background: #007aff;
    border-radius: 28px;
    margin-right: 10px;
    margin-left: 5px;
  }
}

.header-nav .nav-item:hover,
.header-nav .nav-item.active {
  color: #007AFF;
}

.nav-item:hover .extral-link,
.nav-item.active .extral-link {
  color: #007AFF !important;
}

.extral-link {
  color: #000;
}

.dropdown-menu {
  font-weight: 500;
  display: none;
  /* 默认隐藏 */
  position: absolute;
  list-style: none;
  padding: 0;
  margin: 0;
  background-color: #fff;
  color: #333;
  z-index: 1000;
  width: 100%;
  margin-top: 8px;
  min-width: 100%;
  width: auto;
  white-space: nowrap;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.20);
  font-size: 14px;
}
.down-arrow::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid;
  /* 箭头的颜色 */
}

.nav-item:hover>.dropdown-menu{
  display: block;
  /* 悬停时显示 */
}

.dropdown-link {
  display: block;
  padding: 7px 10px;
  text-decoration: none;
  color: #000;
  transition: color 0s;

  &.active {
    color: #007aff;
  }
}

.dropdown-link:hover {
  background: #007aff;
  color: #ffffff;
}

</style>
